(function () {
  'use strict';
  // jscs:disable maximumLineLength

  angular
    .module('wbAccount')
    .config(config);

  function config($translateProvider) {
    $translateProvider.translations('en', {
      'account.change': 'Edit profile',
      'account.change.submit': 'Save personal information changes',
      'account.personalData': 'Personal information',
      'account.titleId': 'Title',
      'account.titleId.1': 'Sir',
      'account.titleId.2': 'Madam',
      'account.name': 'Full name',
      'account.lastName': 'Last name',
      'account.firstName': 'First name',
      'account.contact': 'Contact',
      'account.contact.email': 'E-mail',
      'account.contact.phone': 'Phone number (optional)',
      'account.contact.fax': 'Fax (optional)',
      'account.save': 'Save',
      'account.updated': 'Changes saved.',
      'account.company.change': 'Edit company information',
      'account.company.updated': 'Company information saved.',
      'account.company.companyData': 'Company information',

      'account.company.company.change': 'Edit company information',
      'account.company.name': 'Company name',
      'account.company.companyNumber': 'Company number',
      'account.company.vatNumber': 'VAT number',
      'account.company.bankAccountNumber': 'Bank account number',
      'account.company.staffCount': 'Number of employees',
      'account.company.nameOnCard': 'Company name on card',
      'account.company.nameOnCard.tooltip': 'Name on card<br/>maximum characters: 21.',
      'account.company.contact': 'Contact',
      'account.company.contact.invoiceEmail': 'E-mail address',

      'account.company.address': 'Company address',
      'account.company.address.zipCode': 'Zip code',
      'account.company.address.city': 'City',
      'account.company.address.address': 'Address',
      'account.company.address.countryCode': 'Country',

      'account.company.invoiceAddress': 'Invoice address',
      'account.company.invoiceAddress.zipCode': 'Zip code',
      'account.company.invoiceAddress.city': 'City',
      'account.company.invoiceAddress.address': 'Address',
      'account.company.invoiceAddress.countryCode': 'Country',

      'account.company.deliveryName': 'Delivery name',
      'account.company.deliveryName.lastName': 'Recipients last name',
      'account.company.deliveryName.firstName': 'Recipients first name',
      'account.company.deliveryAddress': 'Delivery address',
      'account.company.deliveryAddress.zipCode': 'Zip code',
      'account.company.deliveryAddress.city': 'City',
      'account.company.deliveryAddress.address': 'Address',
      'account.company.deliveryAddress.countryCode': 'Country',

      'account.company.owner': 'Owner’s information',
      'account.company.owner.titleId': 'Title',
      'account.company.owner.name': 'Owner’s name',
      'account.company.owner.birthName': 'Owner’s birth name',
      'account.company.owner.post': 'Owner’s title',
      'account.company.owner.nationality': 'Nationality',
      'account.company.owner.IDType': 'Type of ID',
      'account.company.owner.IDNumber': 'ID number',

      'account.IDType.1': 'ID type',
      'account.IDType.2': 'Passport',
      'account.IDType.3': 'Driving license',

      'account.company.owner.isForeign': 'Foreign citizenship',
      'account.company.owner.phone': 'Phone number (optional)',
      'account.company.owner.fax': 'Fax (optional)',
      'account.company.owner.email': 'E-mail (optional)',

      'account.company.owner.address': 'Owner’s address',
      'account.company.owner.hungarianAddress': 'Hungarian address',

      'account.company.save': 'Mentés',
      'account.newCardOrder.legend': 'You can order new cards here for your employees. Please click ‘Next’ so you can order them in a few steps.',
      'account.topUp.legend': 'You can top up your cards here after ordering. Please click ‘Next’ so you can top up the cards in a few steps',
      'account.more': 'Next',

      'account.company.openAlert': 'Dear Customer!<br><br>Please note that the modified data will be updated in our systems within 24 hours. If you modify Company name / tax number, it is necessary a new contract, so please contact : 06-1 / 413-3333!<br><br>Thanks, Edenred team',

      'account.company.noCompany': 'We couldn\'t find any company for your account.<br><br>We\'re aware of this error, and our colleges will inform you about the solution via your e-mail address ({{ email }}).<br><br>Thank you for your understanding.'
    });
  }
}());
